import React from "react";
import { Modal, Button, Typography, Divider } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import useAiAssessmentStart from "../../hooks/useAiAssessmentStart";
import "./modals.scss";

const TabSwitchModal: React.FC = () => {
  const {
    showTabSwitchModal,
    setShowTabSwitchModal,
    fullscreenElementRef,
    isFullscreen,
    clearExitFullScreenState,
  } = useAIAssessmentContext();

  const {toggleToFullscreenMode} = useAiAssessmentStart();

  const handleClose = () => {
    setShowTabSwitchModal(false);
    if(!isFullscreen) {
      toggleToFullscreenMode();
    }
    clearExitFullScreenState();
  };

  return (
    <Modal
      closeIcon={false}
      destroyOnClose={true}
      centered
      keyboard={false}
      open={showTabSwitchModal}
      onCancel={handleClose}
      maskClosable={false}
      footer={null}
      getContainer={
        isFullscreen ? () => fullscreenElementRef.current! : undefined
      }
    >
      <div className="modal-content">
        <div className="modal-content-header">
          <Typography.Title level={5} style={{ margin: 0 }}>
            Tab Switch Detected !!
          </Typography.Title>
        </div>
        <Divider style={{ margin: 0 }} />
        <div className="violation-modal-content-icon">
          <WarningOutlined />
        </div>

        <Typography.Text>
          Tab switch has been detected during the AI Assessment Rounds. Please
          ensure you are not switching tabs.
        </Typography.Text>
      </div>
      <div className="ai-assessment-modal-footer">
        <Button type="default" onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default TabSwitchModal;
